import { render, staticRenderFns } from "./StatusFormacao.vue?vue&type=template&id=3d2d22b8&scoped=true"
import script from "./StatusFormacao.vue?vue&type=script&lang=js"
export * from "./StatusFormacao.vue?vue&type=script&lang=js"
import style0 from "./StatusFormacao.vue?vue&type=style&index=0&id=3d2d22b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d22b8",
  null
  
)

export default component.exports